import React from "react";
import { useI18n } from "../lib/i18n";
import { ArrowDown, ArrowRight, Coins, TrendingUp, Wallet, RefreshCw, AlertTriangle, Calendar } from "lucide-react";

export default function Instructions() {
  const { lang } = useI18n();

  const it = lang === "it";

  return (
    <div className="wc-container wc-help" data-testid="help-page">
      <div className="wc-help-hero">
        <span className="wc-eyebrow">{it ? "Guida rapida" : "Quick guide"}</span>
        <h1 className="wc-title">
          {it ? "Come funziona il simulatore" : "How the simulator works"}
        </h1>
        <p className="wc-lead">
          {it
            ? "Un capitale investito matura lo 0,17% al giorno dal terzo giorno. La liquidità generata si reinveste automaticamente oltre $500. Tu decidi solo versamenti e ritiri."
            : "Invested capital yields 0.17% daily from day three. Cash above $500 is auto-reinvested. You only choose deposits and withdrawals."}
        </p>
      </div>

      <div className="wc-help-grid">
        <div className="wc-help-card">
          <div className="wc-help-icon"><Coins /></div>
          <h3>{it ? "1. Versamento" : "1. Deposit"}</h3>
          <p>{it
            ? "Nella colonna Versamento scrivi solo la cifra che vuoi mettere quel mese (minimo $500). Lasciala vuota per non versare."
            : "In the Deposit column, enter the amount you want to add that month (min $500). Leave empty for none."}</p>
          <div className="wc-help-arrow"><ArrowRight /></div>
        </div>

        <div className="wc-help-card">
          <div className="wc-help-icon"><TrendingUp /></div>
          <h3>{it ? "2. Interesse" : "2. Interest"}</h3>
          <p>{it
            ? "Dal terzo giorno l'importo genera 0,17%/giorno di liquidità. Il capitale resta vincolato 12 mesi."
            : "From day 3 your amount generates 0.17%/day of cash. Capital is locked for 12 months."}</p>
          <div className="wc-help-arrow"><ArrowRight /></div>
        </div>

        <div className="wc-help-card">
          <div className="wc-help-icon"><RefreshCw /></div>
          <h3>{it ? "3. Reinvesto auto" : "3. Auto-reinvest"}</h3>
          <p>{it
            ? "Se la liquidità supera $500, viene reinvestita automaticamente il giorno 1 e il giorno 15. Nuovo blocco da 12 mesi."
            : "When cash exceeds $500 it is auto-reinvested on days 1 and 15. New 12-month lock starts."}</p>
          <div className="wc-help-arrow"><ArrowRight /></div>
        </div>

        <div className="wc-help-card">
          <div className="wc-help-icon"><Wallet /></div>
          <h3>{it ? "4. Ritiro" : "4. Withdrawal"}</h3>
          <p>{it
            ? "Nella colonna Ritiro scegli USD o % del guadagno del mese, e se è Spot (una volta) o Continuo (ripetuto ogni mese finché non lo cambi)."
            : "In the Withdrawal column choose USD or % of monthly profit, and Spot (once) or Recurring (every month until changed)."}</p>
        </div>
      </div>

      <div className="wc-help-callouts">
        <div className="wc-callout wc-callout-warn">
          <AlertTriangle />
          <div>
            <strong>{it ? "Allarme capitale" : "Capital warning"}</strong>
            <p>{it
              ? "Se in un mese il ritiro supera il guadagno, la parte in eccesso viene tolta dal capitale."
              : "If a monthly withdrawal exceeds the profit, the excess is taken from your capital."}</p>
          </div>
        </div>
        <div className="wc-callout wc-callout-info">
          <Calendar />
          <div>
            <strong>{it ? "Ripetere una scelta" : "Repeating a choice"}</strong>
            <p>{it
              ? "Impostando la modalità Continuo, la cifra si applica automaticamente ai mesi successivi finché non ne inserisci una nuova (che diventa la nuova standard)."
              : "With Recurring mode, the value applies to all next months until you set a new one (which becomes the new default)."}</p>
          </div>
        </div>
      </div>

      <div className="wc-help-flow">
        <h2 className="wc-h2">{it ? "Cosa vedrai in tabella" : "What you'll see in the table"}</h2>
        <div className="wc-flow-row">
          <div className="wc-flow-step">{it ? "Capitale inizio mese" : "Capital at month start"}</div>
          <ArrowDown className="wc-flow-arrow" />
          <div className="wc-flow-step wc-flow-good">{it ? "Guadagno del mese" : "Month profit"}</div>
          <ArrowDown className="wc-flow-arrow" />
          <div className="wc-flow-step">{it ? "Ritiro (tuo)" : "Your withdrawal"}</div>
          <ArrowDown className="wc-flow-arrow" />
          <div className="wc-flow-step wc-flow-accent">{it ? "Reinvestito automaticamente" : "Auto-reinvested"}</div>
          <ArrowDown className="wc-flow-arrow" />
          <div className="wc-flow-step">{it ? "Capitale fine mese" : "Capital at month end"}</div>
        </div>
      </div>
    </div>
  );
}
